import { createGlobalStyle } from "styled-components";
import { useTranslation } from "react-i18next";
import "./App.css";

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${(props) =>
      props.language === "ka"
        ? "'Noto Sans Georgian', Arial"
        : "'Maison Neue', Arial"};
     
  }
`;

export const GlobalStylesWrapper = ({ children }) => {
  const { i18n } = useTranslation();

  return (
    <>
      <GlobalStyle language={i18n.language} />
      {children}
    </>
  );
};
